let SpnDlg:HTMLDialogElement;
let SpnTimoutID:number;
export function ShowSpinner(delay=0):void {
  if(SpnDlg) return;
  if(SpnTimoutID) { clearTimeout(SpnTimoutID); SpnTimoutID=undefined; }
  if(delay>0) {
    SpnTimoutID = setTimeout(() => { 
      SpnTimoutID=undefined;
      ShowSpinner(0)
    },delay);
    return;
  }
  SpnDlg=document.createElement("dialog");
  SpnDlg.classList.add("overlay");
  SpnDlg.innerHTML='<div class="spinner"></div>';
  SpnDlg.addEventListener("cancel",e=>e.preventDefault());
  document.body.appendChild(SpnDlg);
  SpnDlg.showModal();
}
export function HideSpinner():void {
  if(SpnTimoutID) { clearTimeout(SpnTimoutID); SpnTimoutID=undefined; }
  if(!SpnDlg) return;
  SpnDlg.close();
  SpnDlg.remove();
  SpnDlg=undefined;
}
export async function SpinWhile(p:Promise<any>) {
  if(SpnDlg) {await p; return; } //spinning already - still wait for promise so we won't return early to caller
  ShowSpinner();
  await p;
  HideSpinner();
}